import Vue from "vue";
import Router from "vue-router";
import store from "../../store/index";
import { DealerRoutes } from "./routes/dealerRoutes";
import { AcquisitionRoutes } from "./routes/aquisitionRoutes";
import { InventoryRoutes } from "./routes/inventoryRoutes";
import { ManagementRoutes } from "./routes/managementRoutes";
import { DealerRetailerRoutes } from "./routes/dealerRetailerRoutes";
import { ServiceProviderRoutes } from "./routes/serviceProviderRoutes";
import { DistributorRoutes } from "./routes/distributorRoutes";
import { PDSRoutes } from "./routes/pdsRoutes";
// import {
//   AcquisitionMenu,
//   InventoryMenu,
//   ManagementMenu,
//   DealerMenu,
//   DealerRetailerMenu,
//   ServiceProviderMenu,
//   DistributorMenu,
//   PDSMenu,
//   FinanceMenu,
// } from "../layouts/sidebar/menus";
import { FinanceRoutes } from "./routes/financeRoutes";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

let router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "LoginRedirect",
      path: "/",
      component: () => import("@/views/auth/Login"),
    },
    {
      name: "Login",
      path: "/login",
      component: () => import("@/views/auth/Login"),
      // meta: {
      //   authorize: [""],
      // },
    },

    {
      name: "ChangePassword",
      path: "/change-password",
      component: () => import("@/views/pages/ChangePassword"),
      meta: {
        // authorize: ["loggedIn"],
      },
    },

    {
      name: "DashboardList",
      path: "/select-dashboard",
      component: () => import("@/views/pages/SelectDashboard"),
      meta: {
        authorize: ["loggedIn"],
      },
    },

    // admin_acquisition
    ...AcquisitionRoutes,

    // inventory
    ...InventoryRoutes,

    // ManagementRoutes
    ...ManagementRoutes,

    // DealerRoutes
    ...DealerRoutes,

    ...DealerRetailerRoutes,

    ...ServiceProviderRoutes,

    ...DistributorRoutes,
    ...PDSRoutes,
    ...FinanceRoutes,
    {
      name: "NotFound",
      path: "**",
      component: () => import("@/views/acquisition/404"),
    },
  ],
});

// function getPermission(code) {
//   const f = store.getters.dashboardRole.permissions.filter((obj) => {
//     if (obj.level && obj.level.includes("R")) {
//       // console.log(obj.code.split(".").pop());
//       if (obj.code.split(".").pop() === code) {
//         return true;
//       }
//     }
//   });
//   // console.log(!!f.length, code);
//   return !!f.length;
// }

router.beforeEach((to, from, next) => {
  const { authorize, passThrough } = to.meta;
  // const userRole = store.getters.userRole;
  const isLoggedIn = store.getters.isLoggedIn;
  const { adminLogin } = store.getters.userData;

  // sidebar menus
  // const items = [
  //   // acquisition
  //   ...AcquisitionMenu,

  //   // inventory
  //   ...InventoryMenu,

  //   // management
  //   ...ManagementMenu,

  //   // dealer
  //   ...DealerMenu,

  //   // drs
  //   ...DealerRetailerMenu,

  //   // service provider
  //   ...ServiceProviderMenu,

  //   // service provider
  //   ...DistributorMenu,
  //   // service provider
  //   ...PDSMenu,
  //   ...FinanceMenu,
  // ];

  // const activeRoutes = router.options.routes.filter((obj) => {
  //   if (obj.path.replace("/", "") == userRole) {
  //     return true;
  //   }
  // });

  // console.log(activeRoutes[0].children);
  // console.log(to.path.split("/").pop())

  // const { permissions } = store.getters.dashboardRole;
  // console.log(to);

  if (authorize) {
    store.dispatch("session");

    if (passThrough) {
      return next();
    }
    
    if (!isLoggedIn) {
      // not logged in so redirect to login page with the return url
      return next({ path: "/login", query: { returnUrl: to.path } });
    }

    if (adminLogin.forcePassword) {
      return next({ path: "/change-password" });
    }

    // const currentRoutes = items.filter((item) => {
    //   if (item.role.indexOf(userRole) !== -1 && getPermission(item.code)) {
    //     return item;
    //   }
    // });

    // var path = to.path.split("/").pop();
    // let hasAccess = [];
    // currentRoutes.forEach((item) => {
    //   if (item.to === path) {
    //     hasAccess.push(item);
    //     return;
    //   }

    //   if (item.submenu) {
    //     item.submenu.forEach((el) => {
    //       // console.log(el.to, path);
    //       if (el.to === path) {
    //         hasAccess.push(item);
    //         return;
    //       }
    //     });
    //   }
    // });

    // if (hasAccess.length <= 0) {
    //   console.log("no access");
    //   return next({ path: "/404" });
    //   // return next(from);
    // }

    // if (!getPermission(to.path.split("/").pop())) {
    //   return next({ path: "/404" });
    // }

    // if (authorize[0] == true) {
    //   return next({ path: "/change-password" });
    // }

    // check if route is restricted by role
    // if (authorize.length && !authorize.includes(userRole)) {
    // if (authorize.length) {
      // role not authorised so redirect to home page

      // return next({ path: `/select-dashboard` });
    // }
  }
  // console.log(getPermission(to.path.split("/")[2]));
  // console.log(to.path.split("/")[2]);
  next();
});

export default router;
